import { render, staticRenderFns } from "./ChannelConnectionSidebar.vue?vue&type=template&id=4e01645c&scoped=true"
import script from "./ChannelConnectionSidebar.vue?vue&type=script&lang=js"
export * from "./ChannelConnectionSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChannelConnectionSidebar.vue?vue&type=style&index=0&id=4e01645c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e01645c",
  null
  
)

export default component.exports